import React from 'react';
import {LayerWrapper} from "./style";

export const Layer = () => {
    return (
        <LayerWrapper></LayerWrapper>
    );
};

